export default __webpack_public_path__ + "static/home-about-image-1-2af00f3eb905300cd6326765241bc6bf.jpg";